import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root',
})
export class prevTaskService {
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  private subTaskApiUrl =
    this.O3CoreApiUrl +
    'PMSubTaskWorkOrder/AddPMSubTaskWorkOrderByTaskOrWorkOrder';
  private subTaskApiUrlForUpdate =
    this.O3CoreApiUrl + 'PMSubTaskWorkOrder/UpdatePMSubTaskWorkOrderById';
  constructor(private http: HttpClient) { }

  addPrevTask(data: any): Observable<any[]> {
    return this.http.post<any>(
      this.O3CoreApiUrl + 'add-pm-technician-task',
      data
    );
  }

  updateSubTaskWorkOrder(payload: any): Observable<string> {
    return this.http.post(this.subTaskApiUrlForUpdate, payload, {
      responseType: 'text',
    });
  }
  addSubTaskWorkOrder(payload: any): Observable<string> {
    return this.http.post(this.subTaskApiUrl, payload, {
      responseType: 'text',
    });
  }
  getSubTaskWorkOrderByTaskId(technicianTaskId?: number, technicianExecutionWOID?: number, WOId?: number): Observable<any[]> {
    const params = new HttpParams()
      .set('technicianTaskId', technicianTaskId?.toString())
      .set('technicianExecutionWOID', technicianExecutionWOID?.toString())
      .set('WOId', WOId?.toString());
    return this.http.get<any[]>(this.O3CoreApiUrl + `PMSubTaskWorkOrder/GetSubTaskWorkOrders`, { params });
  }
  deletePrevTask(data: any): Observable<string> {
    return this.http.post<string>(
      this.O3CoreApiUrl + 'PMSubTaskWorkOrder/DeletePMSubTaskWorkOrderById',
      data,
      {
        responseType: 'text' as 'json',
      }
    );
  }
  getPMExternalVendor(data: any): Observable<any[]> {
    return this.http.post<any>(
      this.O3CoreApiUrl + 'PMExternalVendor/GetPMExternalVendor',
      data
    );
  }
  // getSubTaskWorkOrderByTaskId(taskId: number): Observable<any[]> {
  //   let params = new HttpParams().set('taskId', taskId.toString());
  //   return this.http.get<any[]>(`$https://localhost:8051/api/PMSubTaskWorkOrder/GetSubTaskWorkOrders`, { params });
  // }

  updatePrevTask(data: any): Observable<any[]> {
    // return this.http.put<any>(this.baseUrl + 'update-pm-technician-task', data);
    return this.http.put<any>(
      this.O3CoreApiUrl + 'PMTechnicianTask/UpdatePMTechnicianTask',
      data
    );
  }

  //NOT IN USE
  // deletePrevTask(data: any): Observable<any[]> {
  //   return this.http.put<any>(this.baseUrl + 'delete-pm-technician-task', data)
  // }

  //NOT IN USE
  // getPrevTask(id: any): Observable<any[]> {
  //   return this.http.get<any>(this.baseUrl + 'get-pm-technician-task', { params: { TaskId: id } })
  // }

  getPMTechnicianTask(data: any): Observable<any[]> {
    // return this.http.get<any>(this.baseUrl + 'get-technician-task', { params: data });
    return this.http.get<any>(
      this.O3CoreApiUrl + 'PMTask/GetPMTechnicianTask',
      { params: data }
    );
  }
  getPMTechnicianTaskPool(data: any): Observable<any[]> {
    // return this.http.get<any>(this.baseUrl + 'get-technician-task', { params: data });
    return this.http.get<any>(
      this.O3CoreApiUrl + 'PMTask/getPMTechnicianTaskPool',
      { params: data }
    );
  }

  getTechAvailableTime(data: any): Observable<any[]> {
    // return this.http.get<any>(this.baseUrl + 'get-technician-avaltime', { params: data });
    return this.http.get<any>(this.O3CoreApiUrl + 'PMTask/TechAvailableTime', {
      params: data,
    });
  }

  resheduleTask(data: any): Observable<any[]> {
    // return this.http.post<any>(this.baseUrl + 'reshedule-task', data)
    return this.http.post<any>(
      this.O3CoreApiUrl + 'PMTask/ReschedulePMTask',
      data
    );
  }

  resheduleTaskList(data: any): Observable<any[]> {
    return this.http.post<any>(
      this.O3CoreApiUrl + 'PMTask/ReschedulePMTaskList',
      data
    );
  }

  PMTechnicianTaskWorkLog(workLog: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'PMTechnicianTask/PMTechnicianTaskWorkLog',
      workLog
    );
  }

  PMTaskHistoryLog(historyLog: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'PMTask/GetPMTaskHistoryLog',
      historyLog
    );
  }

}
